import { render, staticRenderFns } from "./enquiry-message-edit.vue?vue&type=template&id=650df1ba&scoped=true&"
import script from "./enquiry-message-edit.vue?vue&type=script&lang=js&"
export * from "./enquiry-message-edit.vue?vue&type=script&lang=js&"
import style0 from "./enquiry-message-edit.vue?vue&type=style&index=0&id=650df1ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650df1ba",
  null
  
)

export default component.exports